import React, {
  useEffect,
  useState
} from 'react';

import axios from 'axios';

import {
  useNavigate
} from 'react-router-dom';

import {
  ArrowRight,
  Copy,
  ExternalLink,
  Plus,
  Printer,
  QrCode,
  RefreshCw,
  ShieldCheck,
  Trash2
} from 'lucide-react';

import {
  QRCodeSVG
} from 'qrcode.react';

import {
  Button
} from '../components/ui/button';

import {
  Card
} from '../components/ui/card';

import {
  Input
} from '../components/ui/input';

import {
  Badge
} from '../components/ui/badge';

import ModonLogo from '../components/ModonLogo';


export default function StationFireAccess() {

  const nav = useNavigate();

  const [items, setItems] =
    useState([]);

  const [name, setName] =
    useState('');

  const [issued, setIssued] =
    useState(null);

  const [error, setError] =
    useState('');

  const [saving, setSaving] =
    useState(false);


  const load = async () => {

    try {

      const r =
        await axios.get(
          '/api/station/fire-access',
          {
            withCredentials: true
          }
        );

      setItems(
        Array.isArray(
          r.data
        )
          ? r.data
          : []
      );

    } catch (e) {

      setError(
        e?.response?.data?.detail ||
        'تعذر تحميل رموز الوصول'
      );
    }
  };


  useEffect(() => {
    load();
  }, []);


  const create = async () => {

    if (
      name.trim().length < 2
    ) {
      setError(
        'أدخل اسمًا للرمز مثل: فريق A أو سيارة الصناعية.'
      );
      return;
    }

    try {

      setSaving(true);
      setError('');

      const r =
        await axios.post(
          '/api/station/fire-access',
          {
            name:
              name.trim()
          },
          {
            withCredentials: true
          }
        );

      const url =
        window.location.origin +
        r.data.portal_path;

      setIssued({
        ...r.data,
        url,
      });

      setName('');

      await load();

    } catch (e) {

      setError(
        e?.response?.data?.detail ||
        'تعذر إنشاء QR'
      );

    } finally {

      setSaving(false);
    }
  };


  const regenerate =
    async (item) => {

      if (
        !window.confirm(
          `تجديد QR الخاص بـ "${item.name}"؟ الرمز السابق سيتوقف فورًا.`
        )
      ) {
        return;
      }

      try {

        setError('');

        const r =
          await axios.post(
            `/api/station/fire-access/${item.id}/regenerate`,
            {},
            {
              withCredentials: true
            }
          );

        setIssued({
          ...r.data,

          name:
            item.name,

          url:
            window.location.origin +
            r.data.portal_path,
        });

        await load();

      } catch (e) {

        setError(
          e?.response?.data?.detail ||
          'تعذر تجديد QR'
        );
      }
    };


  const revoke =
    async (item) => {

      if (
        !window.confirm(
          `إلغاء وصول "${item.name}"؟`
        )
      ) {
        return;
      }

      try {

        await axios.post(
          `/api/station/fire-access/${item.id}/revoke`,
          {},
          {
            withCredentials: true
          }
        );

        await load();

      } catch (e) {

        setError(
          e?.response?.data?.detail ||
          'تعذر إلغاء الرمز'
        );
      }
    };


  const copyLink = async () => {

    if (!issued?.url) return;

    await navigator.clipboard.writeText(
      issued.url
    );
  };


  return (
    <div
      dir="rtl"
      className="modon-app-shell"
    >

      <header className="modon-header">

        <div className="modon-header-inner max-w-6xl">

          <div className="flex items-center gap-3">

            <ModonLogo size={42}/>

            <div>
              <h1 className="font-extrabold">
                بوابة فريق الإطفاء
              </h1>

              <p className="text-xs text-slate-500">
                إدارة QR والوصول الميداني
              </p>
            </div>

          </div>


          <Button
            variant="outline"
            onClick={() =>
              nav('/station')
            }
          >
            <ArrowRight size={14}/>
            لوحة المحطة
          </Button>

        </div>

      </header>


      <main className="max-w-6xl mx-auto p-4 md:p-6 space-y-5">

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 p-3 rounded-xl text-sm">
            {error}
          </div>
        )}


        <Card className="p-5">

          <div className="flex items-center gap-2 mb-4">

            <QrCode
              className="text-[#1a4d80]"
            />

            <h2 className="font-extrabold text-[#1a4d80]">
              إنشاء QR جديد
            </h2>

          </div>


          <div className="flex flex-col md:flex-row gap-2">

            <Input
              value={name}
              onChange={
                e =>
                  setName(
                    e.target.value
                  )
              }
              placeholder="مثال: فريق A، سيارة الصناعية، فريق المواد الخطرة..."
            />

            <Button
              onClick={create}
              disabled={saving}
              className="bg-[#1a4d80]"
            >
              <Plus size={14}/>

              {saving
                ? 'جارٍ الإنشاء...'
                : 'إنشاء QR'}
            </Button>

          </div>

        </Card>


        {issued && (

          <Card className="p-6">

            <div
              id="fire-qr-print"
              className="max-w-md mx-auto text-center bg-white"
            >

              <ModonLogo size={60}/>

              <h2 className="font-extrabold text-lg mt-3">
                بوابة فريق الإطفاء
              </h2>

              <p className="text-sm text-slate-600 mt-1">
                {issued.name}
              </p>


              <div className="inline-block mt-5 p-5 bg-white border-4 border-[#1a4d80] rounded-2xl">

                <QRCodeSVG
                  value={
                    issued.url
                  }
                  size={260}
                  level="H"
                  includeMargin
                />

              </div>


              <div
                dir="ltr"
                className="text-[10px] text-slate-500 mt-3 break-all"
              >
                {issued.url}
              </div>


              <p className="text-xs text-red-600 mt-4 font-bold">
                للاستخدام التشغيلي فقط
              </p>

            </div>


            <div className="flex flex-wrap justify-center gap-2 mt-5">

              <Button
                variant="outline"
                onClick={copyLink}
              >
                <Copy size={14}/>
                نسخ الرابط
              </Button>


              <Button
                variant="outline"
                onClick={() =>
                  window.open(
                    issued.url,
                    '_blank',
                    'noopener,noreferrer'
                  )
                }
              >
                <ExternalLink size={14}/>
                اختبار البوابة
              </Button>


              <Button
                className="bg-[#1a4d80]"
                onClick={() =>
                  window.print()
                }
              >
                <Printer size={14}/>
                طباعة QR
              </Button>

            </div>


            <div className="mt-5 rounded-lg bg-amber-50 border border-amber-200 p-3 text-xs text-amber-800">

              احتفظ أو اطبع هذا QR الآن. لأسباب أمنية لا يحتفظ النظام بالنص الأصلي للرمز؛ يحتفظ ببصمته فقط. ويمكنك إنشاء QR جديد لاحقًا بواسطة «تجديد».

            </div>

          </Card>

        )}


        <Card className="p-5">

          <div className="flex items-center justify-between mb-4">

            <div className="flex items-center gap-2">

              <ShieldCheck
                className="text-[#1a4d80]"
              />

              <h2 className="font-extrabold text-[#1a4d80]">
                رموز الوصول
              </h2>

            </div>


            <Button
              size="sm"
              variant="outline"
              onClick={load}
            >
              <RefreshCw size={14}/>
              تحديث
            </Button>

          </div>


          {items.length === 0 ? (

            <div className="text-center text-slate-500 py-8">
              لا توجد أكواد QR حتى الآن.
            </div>

          ) : (

            <div className="space-y-3">

              {items.map(
                item => (

                  <div
                    key={item.id}
                    className="border rounded-xl p-4 flex flex-col md:flex-row md:items-center justify-between gap-3"
                  >

                    <div>

                      <div className="flex items-center gap-2">

                        <div className="font-bold">
                          {item.name}
                        </div>

                        <Badge
                          className={
                            item.active
                              ? 'bg-emerald-600'
                              : 'bg-slate-500'
                          }
                        >
                          {item.active
                            ? 'فعال'
                            : 'ملغي'}
                        </Badge>

                      </div>


                      <div className="text-xs text-slate-500 mt-2">
                        آخر 4 رموز:
                        {' '}
                        <span dir="ltr">
                          ****{item.tokenLast4}
                        </span>
                      </div>


                      <div className="text-xs text-slate-500 mt-1">
                        مرات الاستخدام:
                        {' '}
                        <b>
                          {item.use_count || 0}
                        </b>
                      </div>

                    </div>


                    <div className="flex gap-2">

                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() =>
                          regenerate(item)
                        }
                      >
                        <RefreshCw size={13}/>
                        تجديد QR
                      </Button>


                      {item.active && (
                        <Button
                          size="sm"
                          variant="outline"
                          className="text-red-600"
                          onClick={() =>
                            revoke(item)
                          }
                        >
                          <Trash2 size={13}/>
                          إلغاء
                        </Button>
                      )}

                    </div>

                  </div>

                )
              )}

            </div>

          )}

        </Card>

      </main>

    </div>
  );
}
